"use client"

import { ListItemProps } from '@/types';
import React from 'react';

export const ListItem: React.FC<ListItemProps> = ({ icon, children, isSelected, onClick }) => (
  <li
    className={`inline-flex flex-row items-center py-3 px-4 justify-between text-sm flex-grow flex-shrink-0 font-medium border-b border-gray-200 text-gray-800`}
    onClick={onClick}
  >
    <div className='inline-flex gap-x-3.5 pr-3 font-bold'>
      {icon && <span className="shrink-0 size-4">{icon}</span>}
      {children}
    </div>
    <div className="flex-shrink-0">
      <input
        type="radio"
        className={`form-radio h-4 w-4 ${isSelected ? 'bg-black border-black' : 'bg-white border-black'} focus:ring-0`}
        checked={isSelected}
        readOnly
      />
    </div>
  </li>
);